'use client';

import styled from 'styled-components';

import { SBox, STypography } from 'components/ui';

export const STileContainer = styled(SBox)`
  * {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
`;

export const STileHeader = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 70%;
  max-width: 280px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${STypography} {
    user-select: none;
  }
`;
